/** DEV presentation only. No Owner facts, capability assertions or external media. */
export interface AssetDemoVisual {
  readonly illustration: string;
  readonly introduction: string;
  readonly scenes: readonly string[];
}
const descriptions = [
  [
    '遥控观测平台的示意排版，展示人员远距离了解环境的产品构想。具体性能与用途尚未验证。',
    '建筑火灾',
    '危险区域观察',
  ],
  [
    '多旋翼观测平台的示意排版，展示从空中采集画面的产品构想。具体性能与用途尚未验证。',
    '空中观察',
    '场景记录',
  ],
  [
    '便携环境检测器的示意排版，展示现场信息采集的产品构想。具体参数与用途尚未验证。',
    '环境观察',
    '现场勘查',
  ],
  [
    '便携通信装置的示意排版，展示现场信息传递的产品构想。通信范围与适用性尚未验证。',
    '通信演示',
    '临时工作点',
  ],
  [
    '探测仪器的示意排版，展示现场信息观测的产品构想。探测能力与用途尚未验证。',
    '现场观察',
    '搜救演示',
  ],
  [
    '遥感终端的示意排版，展示远距离环境记录的产品构想。观测能力与用途尚未验证。',
    '远距离观察',
    '环境记录',
  ],
  [
    '便携照明装置的示意排版，展示现场辅助照明的产品构想。照度与适用性尚未验证。',
    '夜间演示',
    '临时工作点',
  ],
  ['水域设备的示意排版，展示水面观察的产品构想。水域能力与用途尚未验证。', '水域观察', '搜救演示'],
  [
    '环境终端的示意排版，展示现场信息采集的产品构想。监测参数与用途尚未验证。',
    '环境记录',
    '现场观察',
  ],
  [
    '移动终端的示意排版，展示现场信息查看的产品构想。通信与决策能力尚未验证。',
    '现场信息',
    '协作演示',
  ],
] as const;
function illustration(index: number): string {
  const shapes = [
    '<rect x="83" y="216" width="274" height="65" rx="32" fill="#283d57"/><circle cx="118" cy="248" r="21"/><circle cx="176" cy="248" r="21"/><circle cx="234" cy="248" r="21"/><circle cx="292" cy="248" r="21"/><rect x="108" y="161" width="208" height="59" rx="16"/><path d="M218 164V105" stroke="#516e8c" stroke-width="12"/><rect x="184" y="76" width="70" height="44" rx="12"/><circle cx="218" cy="98" r="12" fill="#83c7ef"/>',
    '<path d="M118 112L315 234M315 112L118 234" stroke="#455f7d" stroke-width="15"/><ellipse cx="114" cy="108" rx="54" ry="11"/><ellipse cx="320" cy="108" rx="54" ry="11"/><ellipse cx="114" cy="238" rx="54" ry="11"/><ellipse cx="320" cy="238" rx="54" ry="11"/><rect x="178" y="142" width="82" height="70" rx="25"/><circle cx="218" cy="197" r="14" fill="#83c7ef"/>',
    '<rect x="164" y="73" width="112" height="220" rx="23"/><rect x="180" y="103" width="80" height="106" rx="8" fill="#a7d9f3"/><path d="M192 173L209 146L226 182L247 139" fill="none" stroke="#1476c8" stroke-width="5"/><circle cx="220" cy="252" r="16" fill="#6884a2"/>',
    '<rect x="104" y="155" width="232" height="132" rx="16"/><path d="M138 159V60M300 159V80" stroke="#455f7d" stroke-width="12"/><rect x="147" y="190" width="97" height="48" rx="7" fill="#a7d9f3"/><circle cx="283" cy="212" r="14" fill="#6884a2"/>',
    '<rect x="96" y="124" width="248" height="153" rx="23"/><rect x="164" y="96" width="108" height="32" rx="14"/><rect x="127" y="155" width="124" height="81" rx="8" fill="#a7d9f3"/><circle cx="296" cy="193" r="17" fill="#6884a2"/>',
    '<path d="M220 170V284M220 233L149 306M220 233L290 306" stroke="#455f7d" stroke-width="12"/><rect x="143" y="81" width="154" height="91" rx="12"/><circle cx="220" cy="126" r="29" fill="#a7d9f3"/>',
    '<path d="M220 161V285M220 237L156 311M220 237L284 311" stroke="#455f7d" stroke-width="10"/><rect x="154" y="87" width="132" height="78" rx="8"/><rect x="168" y="98" width="104" height="54" rx="6" fill="#fcf1ad"/>',
    '<path d="M82 208Q220 297 358 208L314 157H126Z"/><path d="M93 281Q134 266 175 281T257 281T339 281" stroke="#76b5d7" stroke-width="8" fill="none"/><rect x="161" y="149" width="114" height="62" rx="10" fill="#a7d9f3"/>',
    '<rect x="156" y="104" width="126" height="168" rx="15"/><path d="M220 104V59M176 84H265" stroke="#455f7d" stroke-width="9"/><rect x="173" y="133" width="92" height="81" rx="7" fill="#a7d9f3"/><circle cx="219" cy="243" r="12" fill="#83c7ef"/>',
    '<rect x="82" y="108" width="276" height="172" rx="18"/><rect x="99" y="125" width="242" height="122" rx="8" fill="#a7d9f3"/><path d="M123 155H245M123 178H310M123 201H280" stroke="#77b0d2" stroke-width="8"/><circle cx="220" cy="264" r="7" fill="#83c7ef"/>',
  ];
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 440 360"><defs><linearGradient id="b" x2="1" y2="1"><stop stop-color="#e9f6ff"/><stop offset="1" stop-color="#c6e0f1"/></linearGradient></defs><rect width="440" height="360" rx="20" fill="url(#b)"/><path d="M0 292L106 184L204 279L332 156L440 251V360H0" fill="#d2e8f5"/><ellipse cx="220" cy="311" rx="157" ry="17" fill="#9ebbd0" opacity=".45"/><g fill="#3c5775">${shapes[index]}</g></svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}
const visuals: Readonly<Record<string, AssetDemoVisual>> = Object.freeze(
  Object.fromEntries(
    descriptions.map(([introduction, ...scenes], index) => [
      `synthetic-asset-${String(index + 1).padStart(2, '0')}`,
      Object.freeze({ illustration: illustration(index), introduction, scenes }),
    ]),
  ),
);
export function assetDemoVisual(
  id: string,
  development = import.meta.env.DEV,
): AssetDemoVisual | undefined {
  return development ? visuals[id] : undefined;
}
